const API_URL = import.meta.env.VITE_API_URL;

export const getAssetPath = (path) => API_URL + "/public/assets/" + path;